import { mapSetFormatBase } from "../FsSetFormat";
import { mapPointsDistribution } from "../FsPointsDistribution";
import { RoundsFormat } from "model/Match/Set/Rounds/RoundsFormat";
import { FsRoundsFormat } from "db/model/match/Set/Rounds/FsRoundsFormat";

export const mapRoundsFormat = (
  fsModel: FsRoundsFormat
): RoundsFormat | undefined => {
  const base = mapSetFormatBase(fsModel);
  if (
    !base ||
    !fsModel.numTracks ||
    !fsModel.points ||
    !fsModel.roundsPerTrack
  ) {
    return undefined;
  }

  const points = mapPointsDistribution(fsModel.points);
  if (!points) {
    return undefined;
  }

  return {
    ...base,
    numTracks: fsModel.numTracks,
    points,
    roundsPerTrack: fsModel.roundsPerTrack,
  };
};
